import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, gradient, skinOutline, fill, outline }) {
  const randomGradientId1 = `_${useRandomId()}`

  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        d="M73.71 41.49C73.71 41.49 60.15 34.6 56.1 29.87C51.6 24.61 51.8 1.96997 51.8 1.96997H39.37C39.37 1.96997 39.68 24.72 35.07 29.87C30.18 35.33 17.46 41.29 17.46 41.29C23.65 55.87 36.05 59.59 45.58 59.59C55.11 59.59 67.51 56.07 73.71 41.49Z"
        fill={`url(#${randomGradientId1})`}
        stroke={skinOutline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M87.24 58.39C85.68 46.38 82.03 43.1399 77.36 40.7899C75.06 39.6299 60.53 31.9099 60.53 31.9099C60.53 31.9099 55.62 38.8499 45.94 38.8499C36.26 38.8499 30.64 31.9099 30.64 31.9099C30.64 31.9099 16.2 39.5799 13.8 40.7899C9.13 43.1399 5.57 46.77 3.92 58.39C2.44 69.45 2 72.21 2 72.21H89.15C89.16 72.2 88.54 68.68 87.24 58.39Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M19.4004 37.4199C19.4004 37.4199 23.0304 50.2999 32.2804 51.6199C41.5304 52.9399 45.6604 38.8399 45.6604 38.8399"
        fill={fill}
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M71.76 37.4199C71.76 37.4199 68.13 50.2999 58.88 51.6199C49.63 52.9399 45.5 38.8399 45.5 38.8399"
        fill={fill}
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M45.5797 50.6301C46.491 50.6301 47.2297 49.8913 47.2297 48.98C47.2297 48.0688 46.491 47.3301 45.5797 47.3301C44.6684 47.3301 43.9297 48.0688 43.9297 48.98C43.9297 49.8913 44.6684 50.6301 45.5797 50.6301Z"
        fill={outline}
      />
      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="45.5814"
          y1="43.1398"
          x2="45.5814"
          y2="9.10707"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1476" stopColor={gradient[1]} />
          <stop offset="0.8447" stopColor={gradient[0]} />
        </linearGradient>
      </defs>
    </g>
  )
}
